module.exports = __webpack_public_path__ + "static/sombra@2x-6af29e5bc2dd26d598b7f4d793734845.png";